module.exports = __webpack_public_path__ + "static/project-38735efcbbf58c865826f67077a425d4.jpg";